import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import HomePage from './pages/HomePage';
import QRCodePage from './pages/QRCodePage';
import RegistrationPage from './pages/RegistrationPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/qrcode" element={<QRCodePage />} />
        <Route path="/priority-register" element={<RegistrationPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
